module.exports = __webpack_public_path__ + "img/level.6866d7f5.png";